import { useEffect, useState } from "react";
import compStyle from '../style/styles/Components.module.css';
import mockupStyle from '../style/styles/Mockup.module.css';
import GentooService from "./SDK/GentooService";
import { mockupData } from "../data/mockupData";
import { useParams } from "react-router-dom";

export const MockupShopify = () => {
    let browserWidth = window.innerWidth;
    const [isSmallResolution, setIsSmallResolution] = useState(browserWidth < 601);
    const [visibleGuide, setVisibleGuide] = useState(true);
    const chatUserId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

    window.addEventListener('resize', () => {
        browserWidth = window.innerWidth;
        setIsSmallResolution(browserWidth < 601);
    })

    const handleClickGuideArea = () => {
        setVisibleGuide(false);
    }

    const { shopName } = useParams();

    useEffect(() => {
        GentooService.loadScript()
            .then(() => {
                GentooService.boot({
                    partnerId: mockupData[shopName].externalKey,
                    authCode: chatUserId,
                    itemId: '',
                    displayLocation: "HOME",
                    partnerType: 'shopify',
                });
                GentooService.init({})
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    return (
        <div
            id='gentoo-sc' 
            style={{
                width: '100%',
                height: '100%',
                overflowY: 'scroll',
            }}
        >
            {/* Need to make floating button lower than guide image */}
            <div style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '56px', background: '#444', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <div style={{display: 'flex', width: '100%', maxWidth: '800px', padding: '0 16px', justifyContent: 'center'}}>
                    <img src="/img/units/gentoo-symbol.png" width={32} height={32} />
                    <div className={compStyle.Spacing__16} />
                    <div>
                        <p className="h5 fc-white">This is a demo page, not a real page.</p>
                        <p className="h6 fc-white">Ask Gentoo anything about this page.</p>
                    </div>
                </div>
            </div>
            <div style={{width: '100%', minHeight: '56px'}} />
            <img
                id='img-sc'
                src={mockupData[shopName].backgroundImage}
                width={'100%'}
            />
        </div>
    )
}